<div class="form-modal">
    <mat-dialog-content>
      <div class="img-wrapper">
        <div class="title-wrapper">
          <h1>{{ isEditing ? 'Edit' : isNew ? 'Create New' : 'View' }} Announcement</h1>
        </div>
      </div>
  
      <form [formGroup]="announcementForm" (ngSubmit)="onSubmit()" class="announcement-form">
        <div class="form-wrapper-80">
          <div class="form-group">
            <span class="required">*</span><label>Select Template:</label>
            <mat-form-field appearance="outline" class="wt-mat-form-field">
              <mat-select [disabled]="isViewMode()" formControlName="templateId" (selectionChange)="onTemplateSelect($event.value)">
                <mat-option *ngFor="let template of templates" [value]="template.ID">
                  {{ template.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="announcementForm.get('templateId')?.invalid && (announcementForm.get('templateId')?.touched || submitButtonPressed)" class="error-message">
              Template is required.
            </div>
          </div>
  
          <div class="form-group title-row">
            <div class="title-label">
              <span class="required">*</span>Title:
            </div>
            <input 
              [readonly]="isViewMode()"
              matInput
              formControlName="title"
              class="wt-mat-input"
              placeholder="Announcement Title"
              type="text"
              [ngClass]="{'invalid': announcementForm.get('title')?.invalid && (announcementForm.get('title')?.touched || submitButtonPressed)}"
            />
            <div *ngIf="announcementForm.get('title')?.invalid && (announcementForm.get('title')?.touched || submitButtonPressed)" class="error-message">
              Title is required.
            </div>
          </div>
  
          <div class="form-group">
            <label><span class="required">*</span>Content:</label>
            <ckeditor [readonly]="isViewMode()" formControlName="content" [config]="config"></ckeditor>
            <div *ngIf="announcementForm.get('content')?.invalid && (announcementForm.get('content')?.touched || submitButtonPressed)" class="error-message">
              Content is required.
            </div>
          </div>
  
          <div class="form-group">
            <label><b>Optional:</b> Select the Content to Link in Message</label>
            <mat-form-field appearance="outline" class="wt-mat-form-field">
              <mat-select [disabled]="isViewMode()" formControlName="link" placeholder="None" (selectionChange)="onLinkSelect($event.value)">
                <mat-option *ngFor="let link of linkOptions" [value]="link">{{ link }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="form-group">
            <div class="date-fields">
              <div class="date-field">
                <span class="required">*</span><label>Start Date:</label>
                <mat-form-field appearance="outline" class="wt-mat-form-field">
                  <input matInput [disabled]="isViewMode() || isStartDatePast()" [matDatepicker]="startPicker" [min]="minStartDate()" formControlName="startDate" placeholder="Start Date">
                  <mat-datepicker-toggle matSuffix [for]="startPicker" [disabled]="isViewMode() || isStartDatePast()"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="startDateInvalid()" class="error-message">
                  Start Date is required.
                </div>
              </div>
  
              <div class="date-field">
                <span class="required">*</span><label>End Date:</label>
                <mat-form-field appearance="outline" class="wt-mat-form-field">
                  <input matInput [disabled]="isViewMode()" [matDatepicker]="endPicker" [min]="minEndDate()" formControlName="endDate" placeholder="End Date">
                  <mat-datepicker-toggle matSuffix [for]="endPicker" [disabled]="isViewMode()"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="announcementForm.get('endDate')?.invalid && (announcementForm.get('endDate')?.touched || submitButtonPressed)" class="error-message">
                  End Date is required and must be after Start Date.
                </div>
              </div>
            </div>
          </div>
  
          <div class="fixed-footer">
            <a tabindex="0" class="btn-primary btn-bold btn" (click)="onSubmit()" (keypress)="onSubmit()">
              {{ isEditing ? 'Update Announcement' : isNew ? 'Add Announcement' : 'Close' }}
            </a>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </div> 